import axios from 'axios';
import store from '../store';
import Cookies from 'js-cookie';
// form data
let api_url = store.getState().ui.api_url;

/**********************************************/
/* Name: setCookiesServices */
/* Description: setCookiesServices */
/**********************************************/
export const setCookiesServices = (token, faculty) => {
  const expiresData = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000); // 1 days
  if (token) {
    Cookies.set('token', token, {
      path: '/',
      expires: expiresData,
    });
  }
  if (faculty) {
    Cookies.set('faculty', faculty, {
      path: '/',
      expires: expiresData,
    });
  }
};
/**********************************************/
/* Name: login */
/* Description: login */
/**********************************************/
export const loginRequest = async (userName, password) => {
  const data = {
    userName,
    password,
  };
  try {
    const response = await axios.post(`${api_url}/api/v1/users/login`, data);
    // set cookies
    setCookiesServices(response.data.token, response.data.data.user.faculty);
    return { status: 'success', user: response.data.data.user };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: getStudentData */
/* Description: getStudentData */
/**********************************************/
export const getStudentsData = async (page, limit, facultySelected) => {
  const token = Cookies.get('token');
  const data = {
    faculty: facultySelected,
  };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/getAllStudents?page=${page}&limit=${limit}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      data: response.data.data,
      studentsNumber: response.data.studentsNumber,
      completedStudentsNumber: response.data.completedStudentsNumber,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: searchForStudent */
/* Description: searchForStudent */
/**********************************************/
export const searchForStudent = async (
  nationalID,
  studentName,
  isComplete,
  faculty
) => {
  const token = Cookies.get('token');
  const data = {
    nationalID: nationalID ? nationalID : null,
    studentName: studentName ? studentName : null,
    isComplete: isComplete ? isComplete : null,
    faculty,
  };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/getStudentInfo`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      dataArray: response.data.data,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        statusCode: error.response.status,
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: downloadStudentsImgs */
/* Description: downloadStudentsImgs */
/**********************************************/
export const downloadStudentData = async (faculty, complete = 'complete') => {
  const token = Cookies.get('token');
  const data = {
    faculty,
  };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/downloadStudentData/${complete}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      path: response.data.path,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: change Password Req */
/* Description: change Password Req */
/**********************************************/
export const changePasswordService = async (
  passwordCurrent,
  password,
  passwordConfirm
) => {
  const data = {
    passwordCurrent,
    password,
    passwordConfirm,
  };
  const token = Cookies.get('token');
  try {
    const response = await axios.patch(
      `${api_url}/api/v1/users/updateMyPassword`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: 'success', user: response.data.data.user };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: get Role */
/* Description: get Role */
/**********************************************/
export const getRoleService = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(`${api_url}/api/v1/users/getRole`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      status: 'success',
      role: response.data.data.role,
      passwordChanged: response.data.data.passwordChanged,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/***************************************************************************/
/* Name : get admin  */
/* Description : get admin  */
/***************************************************************************/
export const getMe = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(`${api_url}/api/v1/users/getMe`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      status: 'success',
      data: response.data.data.user,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/***************************************************************************/
/* Name : update account info  */
/* Description : update account info  */
/***************************************************************************/
export const updateAccountInfoService = async (data) => {
  const token = Cookies.get('token');
  try {
    const response = await axios.patch(
      `${api_url}/api/v1/users/updateSuperAdmin`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      data: response.data.user,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name:  deleteStudentsDataService */
/**********************************************/
export const deleteStudentsDataService = async (data) => {
  const token = Cookies.get('token');
  // make the above data as a object
  const dataObj = {
    faculty: data.faculty,
  };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/delete`,
      dataObj,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      data: response.data.deletedData,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name:  uploadStudentsDataService */
/**********************************************/
export const uploadStudentsDataService = async (data) => {
  const token = Cookies.get('token');
  // the data should be a form data
  const dataForm = new FormData();
  dataForm.append('faculty', data.faculty);
  dataForm.append('status', data.status);
  dataForm.append('file', data.file);
  try {
    const response = await axios.post(
      `${api_url}/api/v1/students/upload`,
      dataForm,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      data: response.data.message,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/***************************************************************************/
/* Name : get statistics  */
/* Description : get statistics  */
/***************************************************************************/
export const getStatisticsService = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(
      `${api_url}/api/v1/students/getStatistics`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: 'success',
      allStudentsNumber: response.data.allStudentsNumber,
      allStudentsNumberCompleted: response.data.allStudentsNumberCompleted,
      data: response.data.results,
    };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: deleteStudentData */
/* Description: deleteStudentData */
/**********************************************/
export const deleteStudentDataService = async (id) => {
  const token = Cookies.get('token');
  try {
    const response = await axios.delete(
      `${api_url}/api/v1/students/deleteStudent/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: 'success', message: response.data.message };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};

// social appointment
/**********************************************/
/* Name: get students number Request */
/* Description: get students number Request */
/**********************************************/
export const getStudentsNumberRequest = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(
      `${api_url}/api/v1/users/getAllStudentsNumber`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: 'success', data: response.data.data };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: getAppointedStudents Request */
/* Description: getAppointedStudents Request */
/**********************************************/
export const getAppointedStudentsRequest = async (day) => {
  const token = Cookies.get('token');
  const data = { date: day };
  try {
    const response = await axios.post(
      `${api_url}/api/v1/users/getAppointedStudentsNumber`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: 'success', data: response.data.data };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: sechedule Request */
/* Description: sechedule Request */
/**********************************************/
export const scheduleStudentsRequest = async (data) => {
  const token = Cookies.get('token');
  try {
    const response = await axios.patch(
      `${api_url}/api/v1/users/appointStudents`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: 'success', message: response.data.message };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
/**********************************************/
/* Name: download StudentData */
/* Description: download StudentData */
/**********************************************/
export const downloadStudentDataRequest = async () => {
  const token = Cookies.get('token');
  try {
    const response = await axios.get(
      `${api_url}/api/v1/users/downloadStudentData`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: 'success', data: response.data.path };
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return {
        status: 'error',
        statusCode: error.code,
        message: 'خطأ في الاتصال بالخادم',
      };
    } else {
      return {
        status: 'error',
        message: error.response.data.message,
      };
    }
  }
};
